import React from 'react';
import HotContactPage from './hot-contact';

export default function render(entry, pageTree) {
    return <HotContactPage entry={entry} pageTree={pageTree} />;
}
